module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-riben.326f767f.jpeg";